module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_16.5b6bcfc2.png";